import { OutlinedInput, OutlinedInputProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const OutlinedBoxInputCustom = styled(OutlinedInput)<OutlinedInputProps>(({ theme }) => ({

  color: "black",
  backgroundColor: "white",
  ".MuiOutlinedInput-input": {
    padding: "8px 8px",
    min:0,
    max:100,
    maxLength:3,
    minLength:1
  },
}));

export default OutlinedBoxInputCustom;
